/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantAccess from './tenant-access';
import TenantAccessDetail from './tenant-access-detail';
import TenantAccessUpdate from './tenant-access-update';
import TenantAccessDeleteDialog from './tenant-access-delete-dialog';

const TenantAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantAccess />} />
    <Route path="new" element={<TenantAccessUpdate />} />
    <Route path=":id">
      <Route index element={<TenantAccessDetail />} />
      <Route path="edit" element={<TenantAccessUpdate />} />
      <Route path="delete" element={<TenantAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantAccessRoutes;
